import {
    ajax,
    dataBEFormat,
    formatDayToDanish,
    getContactTime,
    formatDateToDanish,
    getInsuranceTypes,
    formatPrice
} from '../lib';
import {
    setResources,
    setUiStatus,
    setSubmitEndpoint,
    setReceiptEndpoint,
    setPostFormData,
    setFlow,
    setOpenTimesEndpoint,
    setOpeningTimes,
    setSubmitGenesysEndpoint,
    setSubmitInsuranceGuideEndpoint,
    setAddress,
    setMinimal
} from './actions';
import { omitFalsyProps } from 'migration-flos-react';
import {
    selectSubmitEndpoint,
    selectInsurances,
    selectContactOption,
    selectContactDateTimeOption,
    selectContactDate,
    selectContactTime,
    selectContactTimeEnd,
    selectAdditionalInfo,
    selectName,
    selectBirthdate,
    selectEmail,
    selectMobile,
    selectResources,
    selectAddress,
    selectReceiptEndpoint,
    selectOpenTimesEndpoint,
    selectSubmitGenesysEndpoint,
    selectFlow,
    //selectMinimal,
    selectPostFormData,
    selectSubmitInsuranceGuideEndpoint,
    selectMinimal
} from './selectors';
import tracking from './../tracking';
import track, { errorTypes } from 'c9-tracking';

export const initApp = (appConfig) => (dispatch) => {
    const {
        endpoints: { resources, submit, receipt, openTimes, submitGenesys, submitInsuranceGuide },
        minimal,
        flow
    } = appConfig;
    const isPostFormExist =
        'postForm' in appConfig.endpoints &&
        appConfig.endpoints.postForm !== undefined &&
        appConfig.endpoints.postForm !== null;
    const postForm = isPostFormExist ? appConfig.endpoints.postForm : '';
    const { adresse } = isPostFormExist
        ? postForm && postForm.XmlRequest
            ? postForm.XmlRequest.request.customer
            : ''
        : '';

    ajax(resources)
        .then((values) => {
            dispatch(setResources(values));
            dispatch(setSubmitEndpoint(submit));
            dispatch(setSubmitInsuranceGuideEndpoint(submitInsuranceGuide));
            dispatch(setReceiptEndpoint(receipt));
            dispatch(setPostFormData(postForm));
            dispatch(setAddress(adresse));
            dispatch(setOpenTimesEndpoint(openTimes));
            dispatch(setSubmitGenesysEndpoint(submitGenesys));
            dispatch(setMinimal(minimal || false));
            dispatch(setFlow(flow));
            dispatch(setUiStatus(''));
            track.ready(true);
        })
        .catch((e) => {
            track.fault('load resources fail');
            dispatch(setUiStatus('error'));
        });
};

export const fetchOpeningTimeAction = () => async (dispatch, getState) => {
    const {
        url,
        method,
        body: { subject },
        headers
    } = selectOpenTimesEndpoint(getState());

    const data = JSON.stringify({
        subject
    });
    const openTimes = await fetch(url, {
        method,
        body: data,
        headers
    });

    const response = await openTimes.json();
    if (openTimes.status === 200 && response.status === 'OK') {
        await dispatch(setOpeningTimes(response));
    }
};

export const createDataObject = () => (dispatch, getState) => {
    const insuranceData = dispatch(listOfSelectedInsurance(selectInsurances(getState()))).replace(/[1-9]\./g, '');
    const { adminEmail, formName } = selectResources(getState());
    const isPostDataEmpty = selectPostFormData(getState()) === '';

    const data = {
        formName,
        adminEmail,
        insurances: selectInsurances(getState()),
        contactOption: selectContactOption(getState()),
        contactDateTimeOption: selectContactDateTimeOption(getState()),
        contactDate: selectContactDate(getState()),
        contactTime: selectContactTime(getState()),
        additionalInfo: selectAdditionalInfo(getState()),
        name: selectName(getState()),
        birthdate: selectBirthdate(getState()),
        email: selectEmail(getState()),
        mobile: selectMobile(getState()),
        address: selectAddress(getState()),
        productInformation: !isPostDataEmpty ? getProductInformation(getState()) : '',
        priceInformation: !isPostDataEmpty ? getPriceInformation(getState()) : '',
        offerNr: !isPostDataEmpty ? [...new Set(getOfferNumber(getState()))][0] : '',
        minimal: selectMinimal(getState()),
        queueDescription: `\r\n\r\n${insuranceData}\r\n${selectAdditionalInfo(getState())}\r\n${selectName(
            getState()
        )}\r\n${selectEmail(getState())}\r\n${selectAddress(getState()) || ''}`,
        backEndDateFormat:
            selectContactDateTimeOption(getState()) === '1'
                ? `${dataBEFormat(selectContactDate(getState()))}T${selectContactTime(getState())}:00.999`
                : null,
        genesysTimeFormat:
            selectContactDate(getState()) !== '' || selectContactTime(getState()) !== ''
                ? `${dataBEFormat(selectContactDate(getState()))}T${selectContactTime(getState()).split('.')[0]}:00`
                : '',
        genesysEndTimeFormat:
            selectContactDate(getState()) !== '' || selectContactTime(getState()) !== ''
                ? `${dataBEFormat(selectContactDate(getState()))}T${selectContactTimeEnd(getState()).split('.')[0]}:00`
                : ''
    };
    return data;
};

export const navigateToReceipt = () => async (dispatch, getState) => {
    const { receiptUrl } = selectResources(getState());
    const {
        insurances,
        contactOption,
        contactDateTimeOption,
        contactDate,
        contactTime,
        additionalInfo,
        name,
        birthdate,
        email,
        mobile,
        address,
        productInformation,
        priceInformation
    } = dispatch(createDataObject());
    const contactTimeText = dispatch(renderCallTimeText());

    const data = omitFalsyProps({
        insurances,
        contactOption,
        contactDateTimeOption,
        contactDate,
        contactTime,
        contactTimeText,
        additionalInfo,
        name,
        birthdate,
        email,
        mobile,
        address,
        productInformation,
        priceInformation
    });
    dispatch(setUiStatus('submitting'));
    track.info('attempt to navigate to receipt');
    ajax({
        ...selectReceiptEndpoint(getState()),
        data
    })
        .then((res) => {
            track.info('navigating to receipt');
            const receiptId = res.objectId;
            window.location = `${receiptUrl}?id=${receiptId}`;
            dispatch(setUiStatus(''));
        })
        .catch((e) => {
            track.fault('navigate to receipt failed');
            dispatch({
                type: 'navigate receipt error',
                meta: {
                    logLevel: 'error',
                    logMessage: 'navigate receipt error' + e
                }
            });
            dispatch(setUiStatus('error'));
        });
};

export const submitGenesysData = () => async (dispatch, getState) => {
    const {
        contactOption: { subjectNetmode, subjectPhone }
    } = selectResources(getState());
    const { formName, mobile, contactOption, queueDescription, genesysTimeFormat, genesysEndTimeFormat } = dispatch(
        createDataObject()
    );
    const subject = contactOption === 'PHONE' ? subjectPhone : subjectNetmode;
    const data = JSON.stringify({
        phone: mobile,
        subject,
        flow: formName,
        queueDescription,
        ...(genesysTimeFormat && { callbackStartTime: genesysTimeFormat, callbackEndTime: genesysEndTimeFormat })
    });

    const { url, method, headers } = selectSubmitGenesysEndpoint(getState());
    const submit = await fetch(url, {
        method: method,
        body: data,
        headers
    });

    try {
        const response = await submit.json();
        const isSuccess = 'CreateWebCallbackResult' in response;
        track.info('genesys request successful');
        return isSuccess;
    } catch (error) {
        track.info('genesys request failed');
        dispatch(setUiStatus('error'));
    }
};

// Submits the form and send e-mails
export const submitForm = () => async (dispatch, getState) => {
    dispatch(setUiStatus('submitting'));
    track.interact('user submitted form');
    const state = getState();
    const { productInformation, priceInformation, offerNr } = dispatch(createDataObject());
    const flow = selectFlow(state);
    const {
        insurances,
        additionalInfo,
        contactOption,
        //backEndDateFormat,
        name,
        birthdate,
        address,
        email,
        mobile
        //minimal
    } = dispatch(createDataObject());
    const insuranceType = await dispatch(listOfSelectedInsurance(insurances));
    let submitEndpoint;
    let data;

    if (flow === 'INSURANCE_GUIDE') {
        data = {
            firstName: name.split(' ')[0],
            fullName: name,
            birthdate,
            contactTime: dispatch(renderCallTimeText()),
            offerNr,
            productInformation,
            priceInformation,
            address,
            mobile,
            email,
            customerComments: additionalInfo,
            requestedInsurances: insuranceType.length
                ? insuranceType.split('|').map((insurance) => insurance.split('.').pop())
                : []
        };
        submitEndpoint = selectSubmitInsuranceGuideEndpoint(state);
    } else {
        const birth = birthdate.split('-').reverse().join('-');
        const localDate = new Date(birth).toLocaleDateString('da-DK', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });

        data = {
            contextData: {
                appName: 'get-quote-app',
                recipientEmail: email,
                interessentId: 'UNKNOWN',
                variables: {
                    customerData: {
                        customerNumber: 'UNKNOWN',
                        customerFirstName: name.split(' ')[0],
                        customerFullName: name,
                        customer_email: email,
                        customer_birthdate: localDate,
                        customer_address: address,
                        customer_phone: mobile.match(/.{1,2}/g).join(' ')
                    },
                    segment: 'private'
                }
            }
        };
        submitEndpoint = selectSubmitEndpoint(state);
    }

    const contactType = contactOption === 'WEB_MEETING' ? 'netmeeting' : 'phone';

    /**BWG -- Sending information to SAS 360*/
    insuranceType.split('|');
    let fields = [];
    let insuranceTypeList = insuranceType.split('|');
    for (let ins in insuranceTypeList) {
        fields.push({
            value: insuranceTypeList[ins],
            name: insuranceTypeList[ins].split('.')[1],
            id: 'field' + ins + insuranceTypeList[ins].split('.')[0]
        });
    }

    track.interact(fields);
    // Hack - send to Genesys is removed
    const isSubmittedToGenesys = true;
    if (isSubmittedToGenesys) {
        ajax({
            ...submitEndpoint,
            data
        })
            .then((res) => {
                if (res.statusCode === 200) {
                    track.info('submit successful');
                    tracking.pushEvent('requestInsuranceOffer', {
                        contactType,
                        insuranceType
                    });
                    dispatch(navigateToReceipt());
                } else {
                    track.fault('submit failed');
                    dispatch(setUiStatus('error'));
                }
            })
            .catch((e) => {
                track.fault('submit failed', errorTypes.tech, '', JSON.stringify(e));
                dispatch({
                    type: 'submit error',
                    meta: {
                        logLevel: 'error',
                        logMessage: 'submit error ' + e + 'Endpoint: ' + JSON.stringify(submitEndpoint)
                    }
                });
                dispatch(setUiStatus('error'));
            });
    } else {
        dispatch(setUiStatus('error'));
    }
};

const listOfSelectedInsurance = (selectedInsurances) => (_, getState) => {
    const {
        section1: { insurances }
    } = selectResources(getState());
    const insuranceList = Object.values(insurances)
        .map((insurance) =>
            Object.keys(insurance)
                .filter((key) => key !== 'title')
                .map((key) => [key, insurance[key]])
        )
        .reduce((a, b) => a.concat(b), []);

    return selectedInsurances.map((insurance) => insuranceList.find((x) => x[0] === insurance)[1]).join('|');
};

const renderCallTimeText = () => (dispatch, getState) => {
    const {
        contact: {
            asap,
            during,
            phone: {
                ring: { and, between }
            }
        }
    } = selectResources(getState());

    const { contactDateTimeOption, contactDate, contactTime } = dispatch(createDataObject());
    if (typeof contactDateTimeOption !== 'undefined' && contactDateTimeOption === '0') {
        return asap;
    } else if (contactTime.length) {
        return `${formatDayToDanish(contactDate)} ${between} ${getContactTime(contactTime, and)}`;
    } else if (contactDate.length) {
        return `${formatDateToDanish(contactDate)} ${during}`;
    } else {
        return null;
    }
};

const getOfferNumber = (state) => {
    const { response } = selectPostFormData(state).XmlResponse;
    return Object.entries(response)
        .filter((item) => typeof item[1] === 'object')
        .map((item) => item[1].statusmessage?.split(' ').pop());
};

const getProductTitles = (state, insuranceType) => {
    const insuranceTypes = getInsuranceTypes();
    const {
        fsguide,
        section1: { insurances }
    } = selectResources(state);
    let productLine = '';

    if (insuranceType === insuranceTypes.bil) {
        productLine = fsguide.bilforsikring;
    } else if (insuranceType === insuranceTypes.ulykke) {
        productLine = fsguide.ulykkeforsikring;
    } else if (insuranceType === insuranceTypes.indbo) {
        productLine = fsguide.indboforsikring;
    } else if (insuranceType === insuranceTypes.hus) {
        productLine = fsguide.husforsikring;
    } else if (insuranceType === insuranceTypes.fritid) {
        productLine = fsguide.fritidshusforsikring;
    } else if (insuranceType === insuranceTypes.aarsrejse) {
        productLine = fsguide.aarsrejseforsikring;
    }

    const category = Object.keys(insurances).find((key) => {
        const values = [];
        Object.entries(insurances[key]).forEach(([insuranceKey, value]) => {
            if (insuranceKey !== 'title') {
                values.push(value);
            }
        });

        return values.find((value) => value.includes(productLine));
    });

    return {
        productHeader: category ? insurances[category].title : '',
        productLine
    };
};

const getProductPrices = (state, insuranceType) => {
    const { produktpris, produktsamlerabat, selvrisiko, sum_doed_dig } =
        selectPostFormData(state).XmlResponse.response[insuranceType];
    const { fsguide } = selectResources(state);

    return {
        priceNoRebate: `${formatPrice(produktpris)} ${fsguide.peryear}`,
        priceWRebate: `${formatPrice(produktsamlerabat)} ${fsguide.peryear}`,
        selvrisiko: selvrisiko ? `${formatPrice(selvrisiko)} ${fsguide.peryear}` : 0,
        sum_doed_dig: sum_doed_dig ? `${formatPrice(sum_doed_dig)} ${fsguide.peryear}` : 0
    };
};

const getProductInformation = (state) => {
    const { response } = selectPostFormData(state).XmlResponse;
    const { request } = selectPostFormData(state).XmlRequest;

    let antal_voksne = 0;
    let antal_boern = 0;
    if (request.insurancerequest.aarsrejse) {
        antal_voksne = request.insurancerequest.aarsrejse.antal_voksne;
        antal_boern = request.insurancerequest.aarsrejse.antal_boern;
    }

    return Object.entries(response)
        .filter((item) => typeof item[1] === 'object')
        .map((item) => {
            const insuranceType = item[0];
            const coverages = getCoverages(state, response, insuranceType);
            const { productHeader, productLine } = getProductTitles(state, insuranceType);
            const { priceNoRebate, priceWRebate, selvrisiko, sum_doed_dig } = getProductPrices(state, insuranceType);
            const insurance = getProductRequestData(state, insuranceType);
            return {
                productHeader,
                productLine,
                priceNoRebate,
                priceWRebate,
                insuranceType,
                coverages,
                selvrisiko,
                sum_doed_dig,
                antal_voksne,
                antal_boern,
                insurance
            };
        });
};

const getPriceInformation = (state) => {
    const { fsguide } = selectResources(state);
    const { response } = selectPostFormData(state).XmlResponse;
    const { prisudenrabat, prismedrabat, rabat } = response;
    return {
        prisudenrabat: `${formatPrice(prisudenrabat)} ${fsguide.peryear}`,
        prismedrabat: `${formatPrice(prismedrabat)} ${fsguide.peryear}`,
        rabat: `${formatPrice(rabat)} ${fsguide.peryear}`
    };
};

const getCoverages = (state, response, insuranceType) => {
    const { fsguide } = selectResources(state);
    return Object.entries(response[insuranceType])
        .filter((key) => key[1] === true || key[1] === 'true')
        .map((item) => fsguide[insuranceType].coverage[item[0]]);
};

const getProductRequestData = (state, insuranceType) => {
    const { insurancerequest } = selectPostFormData(state).XmlRequest.request;
    const { fsguide } = selectResources(state);
    const { fabrikat, model, motor, reg_nr, koersel_aar, forsikringssum_varigt_men, indbosum } =
        insurancerequest[insuranceType];

    return {
        fabrikat,
        model,
        motor,
        reg_nr,
        koersel_aar,
        forsikringssum_varigt_men: forsikringssum_varigt_men
            ? `${formatPrice(forsikringssum_varigt_men)} ${fsguide.peryear}`
            : 0,
        indbosum: indbosum ? `${formatPrice(indbosum)} ${fsguide.peryear}` : 0
    };
};
